<template>
  <div class="stepOut">
    <div class="stepItem">
      <p :class="stepInfo.status >= 1 ? 'blue' : 'gray'">买家下单</p>
      <p class="time">{{ stepInfo.buyTime }}</p>
      <!-- <div
        :class="
          stepInfo.status >= 1 ? 'stepItem_xian lineAction' : 'stepItem_xian'
        "
      ></div> -->
      <div v-if="stepInfo.status >= 1" class="stepItem_xian">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
      <div v-else class="stepItem_xian">
        <div class="dot1"></div>
        <div class="dot1"></div>
        <div class="dot1"></div>
        <div class="dot1"></div>
        <div class="dot1"></div>
        <div class="dot1"></div>
      </div>
    </div>
    <div class="stepItem shenheStatus">
      <p
        :class="
          stepInfo.status == 2 ||
          stepInfo.status == 6 ||
          stepInfo.status == 4 ||
          stepInfo.status == 3 ||
          stepInfo.status == 5
            ? 'blue'
            : 'gray'
        "
      >
        付款成功
      </p>
      <p class="time">{{ stepInfo.payTime }}</p>
      <div
        v-if="
          stepInfo.status == 2 ||
          stepInfo.status == 3 ||
          stepInfo.status == 4 ||
          stepInfo.status == 5 ||
          stepInfo.status == 6
        "
        class="stepItem_xian"
      >
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
      <div v-else class="stepItem_xian">
        <div class="dot1"></div>
        <div class="dot1"></div>
        <div class="dot1"></div>
        <div class="dot1"></div>
        <div class="dot1"></div>
        <div class="dot1"></div>
      </div>
      <div v-if="statustype == 3" class="close"></div>
      <!--  -->
    </div>
    <div class="stepItem">
      <p
        :class="
          stepInfo.status == 5 ||
          (stepInfo.status == 6 && stepInfo.status != '99')
            ? 'blue'
            : 'gray'
        "
      >
        商家发货
      </p>
      <p class="time">{{ stepInfo.postTime }}</p>
      <div
        v-if="stepInfo.status == 5 || stepInfo.status == 6"
        class="stepItem_xian"
      >
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
      <div v-else class="stepItem_xian">
        <div class="dot1"></div>
        <div class="dot1"></div>
        <div class="dot1"></div>
        <div class="dot1"></div>
        <div class="dot1"></div>
        <div class="dot1"></div>
      </div>
      <div
        class="dots"
        v-if="stepInfo.status == 5 || stepInfo.status == 6"
      ></div>
      <div class="btn" v-if="stepInfo.status == 5 || stepInfo.status == 6">
        <el-button class="whiteBtn" @click="examine">查看物流</el-button>
      </div>
    </div>
    <div class="stepItem">
      <p :class="stepInfo.status == 6 ? 'blue' : 'gray'">交易完成</p>
      <p class="time">{{ stepInfo.completeTime }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'steps',
  props: {
    // 传递步骤参数
    stepInfo: {
      type: Object,
      default: function () {
        return {
          list: []
        }
      }
    },
    statustype: {
      type: String

    }
  },
  methods: {
    examine () {
      this.$parent.examine()
    }
  }

}
</script>

<style lang="scss" scoped>
.stepOut {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-top: 20px;
  .stepItem {
    width: 208px;
    height: 80px;
    background: #e9ecfe;
    opacity: 1;
    border-radius: 40px;
    text-align: center;
    position: relative;
    box-sizing: border-box;
    padding-top: 15px;
    .stepItem_xian {
      position: absolute;
      left: 110%;
      top: 40px;
      width: 50%;
      // height: 0px;
      // border: 1px dashed #cccccc;
      display: flex;
      justify-content: space-between;
    }
    .dot {
      width: 4px;
      height: 4px;
      background: #2d46ee !important;
      border-radius: 50%;
      opacity: 1;
    }
    .dot1 {
      width: 4px;
      height: 4px;
      background: #e9ecfe !important;
      border-radius: 50%;
      opacity: 1;
    }
    .dots {
      position: absolute;
      left: 134%;
      top: 10px;
      width: 4px;
      height: 4px;
      background: #2d46ee !important;
      border-radius: 50%;
      opacity: 1;
    }
    .btn {
      position: absolute;
      left: 110%;
      top: -40px;
    }
    .whiteBtn {
      width: 120px;
      height: 36px;
      background: #ffffff;
      border: 1px solid #4168e7;
      opacity: 1;
      border-radius: 4px;
      line-height: 0;
      color: #4168e7;
    }
    .lineAction {
      // border: 1px dashed #4c81eb;
    }
    .blue {
      width: 112px;
      height: 36px;
      line-height: 36px;
      background: #2d46ee;
      opacity: 1;
      border-radius: 35px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      margin-left: 48px;
    }
    .gray {
      width: 112px;
      height: 36px;
      line-height: 36px;
      background: #ffffff;
      border-radius: 35px;
      font-size: 16px;
      font-weight: 400;
      color: #c0c0cc;
      margin-left: 48px;
    }
    .time {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 0px;
      color: #2d46ee;
      margin-top: 10px;
    }
  }
  .shenheStatus {
    position: relative;
    .close {
      position: absolute;
      left: 77%;
      top: 54px;
      width: 50%;
      height: 0px;
      border: 1px dashed red;
      &:before {
        width: 8px;
        height: 8px;
        background: red;
        border-radius: 50%;
        content: "";
        color: red;
        position: absolute;
        border: 3px solid #f5d3d9;
        left: 45%;
        top: -7px;
      }
      &:after {
        width: 100%;
        content: "审核不通过";
        color: red;
        position: absolute;
        left: 0%;
        top: -39px;
        font-size: 14px;
        font-weight: bold;
      }
    }
  }
}
@media screen and (max-width: 1280px) {
  .stepOut {
    display: flex;
    justify-content: center;
    .stepItem {
      width: 16%;
      height: 140px;
      text-align: center;
      position: relative;
      box-sizing: border-box;
      padding-top: 15px;
      .stepItem_img {
        width: 48px !important;
        height: 48px !important;
      }
      .stepItem_xian {
        position: absolute;
        left: 77%;
        top: 54px;
        width: 50%;
        height: 0px;
        border: 1px dashed #cccccc;
      }
      .lineAction {
        border: 1px dashed #4c81eb;
      }
      .blue {
        font-size: 14px;
        font-weight: bold;
        color: #333333;
      }
      .gray {
        font-size: 14px;
        font-weight: 400;
        color: #cccccc;
      }
      .time {
        font-size: 14px;
        font-weight: 400;
        color: #999999;
      }
    }
    .shenheStatus {
      position: relative;
      .close {
        position: absolute;
        left: 77%;
        top: 54px;
        width: 50%;
        height: 0px;
        border: 1px dashed red;
        &:before {
          width: 8px;
          height: 8px;
          background: red;
          border-radius: 50%;
          content: "";
          color: red;
          position: absolute;
          border: 3px solid #f5d3d9;
          left: 45%;
          top: -7px;
        }
        &:after {
          width: 100%;
          content: "审核不通过";
          color: red;
          position: absolute;
          left: 0%;
          top: -39px;
          font-size: 14px;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
